import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPutEdc_sharing_groupIdKeys = z.any()
export type TagsPutEdc_sharing_groupIdKeys = z.infer<typeof tagsPutEdc_sharing_groupIdKeys>

export const paramsPutEdc_sharing_groupIdKeys = z.object({ "groupId": z.string() })
export type ParamsPutEdc_sharing_groupIdKeys = z.infer<typeof paramsPutEdc_sharing_groupIdKeys>

export const bodyPutEdc_sharing_groupIdKeys = z.object({ "keys": z.record(z.number().gte(0).lte(1)).superRefine((value, ctx) => {
for (const key in value) {
if (key.match(new RegExp("^(.*)$"))) {
const result = z.number().gte(0).lte(1).safeParse(value[key])
if (!result.success) {
ctx.addIssue({
          path: [...ctx.path, key],
          code: 'custom',
          message: `Invalid input: Key matching regex /${key}/ must match schema`,
          params: {
            issues: result.error.issues
          }
        })
}
}
}
}) })
export type BodyPutEdc_sharing_groupIdKeys = z.infer<typeof bodyPutEdc_sharing_groupIdKeys>

export const responsePutEdc_sharing_groupIdKeys = z.object({ "payload": z.object({ "keys": z.record(z.number().gte(0).lte(1)).superRefine((value, ctx) => {
for (const key in value) {
if (key.match(new RegExp("^(.*)$"))) {
const result = z.number().gte(0).lte(1).safeParse(value[key])
if (!result.success) {
ctx.addIssue({
          path: [...ctx.path, key],
          code: 'custom',
          message: `Invalid input: Key matching regex /${key}/ must match schema`,
          params: {
            issues: result.error.issues
          }
        })
}
}
}
}) }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePutEdc_sharing_groupIdKeys = z.infer<typeof responsePutEdc_sharing_groupIdKeys>

interface IPutEdc_sharing_groupIdKeys extends BaseMethodType {
  tags: TagsPutEdc_sharing_groupIdKeys,
  params: ParamsPutEdc_sharing_groupIdKeys,
  body: BodyPutEdc_sharing_groupIdKeys,
  response: ResponsePutEdc_sharing_groupIdKeys
}
export const URL = '/edc-sharing/:groupId/keys'
export const validation = {
  put: {
    tags: tagsPutEdc_sharing_groupIdKeys,
    params: paramsPutEdc_sharing_groupIdKeys,
    body: bodyPutEdc_sharing_groupIdKeys,
    response: responsePutEdc_sharing_groupIdKeys
  }
}
export interface Edc_sharing_groupIdKeys extends BaseRouteType {
  put: IPutEdc_sharing_groupIdKeys
}